import { array, boolean, InferType, object, string } from "yup";

export type IFormularioBaseSchema = InferType<typeof formBaseSchema>;

export const formBaseSchema = object({
  date: string().required(),
  empresa: string().optional(),
  selecionarPeriodo: boolean().required(),
  inicio: string().nullable(),
  fim: string().nullable(),
  metadata: array(string().required()).default(() => []),
  empresaIsEnabled: boolean().optional()
});
